import { useController } from "react-hook-form";
import { RadioGroup } from "../Radio/RadioGroup";
import { FormRadioProps } from "./Form.types";
import FormField, { useFormField } from "./FormField/FormField";

/**
 * @deprecated
 * This component uses AntD and Moment which are deprecated in our stack
 * TODO: We will migrate this component to MUI via this ticket
 * https://clipboardhealth.atlassian.net/browse/CH-25251
 */
export function FormRadioGroup(props: FormRadioProps) {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <RadioGroup {...field} {...childProps} />
    </FormField>
  );
}
